@if (isVisible) {
    <ng-container *ngIf="tabs$ | async as tabs">
        <ds-tabs-group
            msThemedTabs
            size="large"
            fullWidthTabs="true"
            inverse="false"
            scrollable="true"
            showBorderBottom="true"
            scrollSpeed="slow"
            [themedSize]="themedSize"
            [activeTab]="selectedBetslipType"
            (activeTabChanged)="onSelectBetslipType($event)">
            @for (tab of tabs; track tab.type) {
                <ds-tab [name]="tab.type.toString()" [title]="tab.title" [disabled]="!isTabEnabled(tab.type.toString())"> </ds-tab>
            }
            <ds-divider />
        </ds-tabs-group>
    </ng-container>
}
